import _ from 'lodash';

import COMMON_IMPORTS from './common.imports';

import './services.bundle.scss';

import commonFiltersMod from './common/filters';
import servicesModule from './services/services.component';
import defaultConfigs from './common.config';
import defaultRuns from './common.run';
import translationServiceMod from './common/translation.service';
import {
  serviceURL
} from './common/common.urls';

let mod = angular.module('servicesMain', _.union(
  COMMON_IMPORTS,
  defaultConfigs.imports,
  defaultRuns.imports,
  [
    commonFiltersMod,
    servicesModule,
    translationServiceMod
  ]
)).controller('ServicesBundleController', function ($scope, $compile, $element, $window, TranslationService) {
  TranslationService.waitForTranslations().finally(() => {
    $scope.onServiceSelected = service => $window.location.href = serviceURL(service);

    const location = $element[0].dataset['location'];
    const locationAttribute = `location-id="${location}"`

    const person = $element[0].dataset['person'];
    const personAttribute = `person-id="${person}"`

    const element = angular.element(`
      <services service-selected-callback="onServiceSelected(service)"
                ${location ? locationAttribute : ''} ${person ? personAttribute : ''}>
      </services>`);

    $compile(element)($scope);

    // Render the locations widget
    $element.append(element);
  });
});

mod = defaultConfigs(mod);
mod = defaultRuns(mod);

export default mod.name;
